import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import ProjectedIncomeComp from './ProjectedIncomeComp';

function ProjectedIncome() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <ProjectedIncomeComp />
      </div>
    </div>
  );
}

export default ProjectedIncome;
